import { FC } from "react";
import moment from "moment";
import PagesByIdAnalyst from "./PagesByIdAnalyst";
import Quill from "../../../../components/common/quill/Quill";

interface Props {
  title: string;
  date: string;
  content: string;
}

const PagesByIdCard: FC<Props> = ({ content, title, date }) => {
  const createDate = moment(date).format("DD.MM.YYYY");

  return (
    <>
      <div className="flex items-center text-sm pt-5">
        <PagesByIdAnalyst publicationDate={createDate} />
      </div>
      <div>
        <h3 className="py-5 text-2xl font-semibold">{title}</h3>
        <div className="max-w-[21.25rem] min-w-[21.25rem] h-auto flex justify-start items-center overflow-hidden rounded-md"></div>
        <p className="py-5">
          <Quill text={content} className={"news"} />
        </p>
      </div>
    </>
  );
};

export default PagesByIdCard;
